import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { error } from 'console';
import { add, format } from 'date-fns';
import { PaymentService } from 'src/app/services/payment.service';
@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss'],
})
export class ResultComponent implements OnInit {
  token!: any;
  transactionStatus!: any;
  successful: boolean = false;
  isLoading: boolean = true;
  method = '';
  isInvoice: boolean = false;
  role!: any;

  constructor(
    private route: ActivatedRoute,
    private paymentSvc: PaymentService
  ) { }

  ngOnInit(): void {
    this.role = sessionStorage.getItem('role') || '';
    if (this.method == 'khipu') {
      console.log(this.token);
      this.paymentSvc.resultPaymentKhipu(this.token).subscribe(
        async (data) => {
          if (data.statusPay == 'PAY') {
            this.successful = true;
            console.log('resultado del status ', data);
            this.transactionStatus = data;
            this.isLoading = false;
          }
        },
        (error) => {
          this.successful = false;
        }
      );
    } else if (this.method == 'multi-transbank') {
      this.paymentSvc.paymentsStatusTBK(this.token).subscribe(
        (data) => {
          console.log('resultado del pago ', data);
          this.successful = true;
          console.log('resultado del status ', data);
          this.transactionStatus = data;
          this.isLoading = false;
        },
        (error) => {
          this.successful = false;
        }
      );
    } else if (this.method == 'multi-khipu') {
      this.paymentSvc.paymentsStatusKhipu(this.token).subscribe(
        async (data) => {
          if (data.statusPay == 'PAY') {
            this.successful = true;
            console.log('resultado del status ', data);
            this.transactionStatus = data;
            this.isLoading = false;
          }
        },
        (error) => {
          this.successful = false;
        }
      );
    } else {
      let resultFunction = this.isInvoice
        ? this.paymentSvc.resultPaymentTransBank(this.token)
        : this.paymentSvc.payStatusTransBank(this.token);
      resultFunction.subscribe(
        (data) => {
          console.log('resultado del pago ', data);
          //let id = data._id;
          this.successful = true;
          //let id = '61d447899e431a5d423ed391';  id de una transaccion valida para generar data

          console.log('resultado del status ', data);
          this.transactionStatus = data;
          this.isLoading = false;
        },
        (error) => {
          this.successful = false;
        }
      );
    }
  }

  reloadPage() {
    window.location.reload();
  }

  formatDate(item: any) {
    let date = new Date(item);
    let dayplus = add(date, {
      days: 1,
    });
    const pattern = 'dd/MM/yyyy';
    return format(dayplus, pattern);
  }
}
